import { useRequestsBase } from './useRequestsBase'

export function useMyPendingRequests() {
  return useRequestsBase({
    topLevelFilter: 'minePending',
  })
}
